'use client';
import React from 'react';
import { Div, Media, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import Link from 'next/link';
import BackgroundImage from '../sub-component/background-image';

const imageSize = {
  Mobile: {
    height: '198px',
    width: '125px',
  },
  MobileHor: {
    height: '280px',
    width: '190px',
  },
  Tablet: {
    width: '170px',
    height: '269px',
  },
  TabletHor: {
    width: '170px',
    height: '269px',
  },
  HD: {
    width: '386px',
    height: '618px',
  },
  MidHD: {
    width: '379px',
    height: '602px',
  },
  FullHD: {
    width: '438px',
    height: '694px',
  },
};

const DownloadSection = ({ translate }: {translate: any}) => {
  if (process.env.APPLICATION_BOX_SHOW === 'true') {
    return (
      <Div className={'flex-col md:flex-row-reverse items-center py-2 mt-8 w-full'}>
        <BackgroundImage imageSize={imageSize}>
          <Image
            alt={'image'}
            sizes={'(max-width: 639px) 50vw, 25vw'}
            src={'/images/home-screen/background-svg/phone.png'}/>
        </BackgroundImage>
        <Div className={'flex-col self-center w-full md:w-1/2 items-center gap-4'}>
          <Text color={'grey.900'} typography={'xxl'} type={'bold'}>
            {translate.title}
          </Text>
          <Div className={'justify-center'}>
            <Text className={'w-3/4 mt-4'} color={'grey.500'} typography={'base'}>
              {translate.sub_title}
            </Text>
          </Div>
          <Media greaterThan={'sm'}>
            <Div className={'flex-col self-center items-center mt-8 mb-9 gap-y-3 md:gap-y-10'}>
              <Div className={'contain relative sm:w-32 sm:h-32 md:w-52 md:h-52'}>
                <Image alt={'qr code'} src={'/images/qr-code.webp'} sizes={'(max-width: 1024px) 50vw, 33vw'}/>
              </Div>
              <Text className={'w-full'} type={'medium'} typography={'base'} color={'grey.900'}>
                {translate.qr_code_text}
              </Text>
            </Div>
          </Media>
          <Div className={'flex-col flex-wrap self-center items-center justify-around w-full'}>
            <Div className={'grid grid-cols-2 sm:grid-cols-4 gap-3 w-full'}>
              <Link passHref={true} href={'https://play.google.com/store/apps/details?id=com.pezeshkbook'} className={'justify-around flex'} target={'_blank'}>
                <Div className={'relative w-48 h-12'}>
                  <Image alt={'google play'} className={'object-contain'} sizes={'(max-width: 639px) 20vw, 15vw'} src={'/images/home-screen/logo/google-play-logo.png'}/>
                </Div>
              </Link>
              <Link passHref={true} href={'https://cafebazaar.ir/app/com.pezeshkbook'} className={'justify-around flex'} target={'_blank'}>
                <Div className={'relative w-48 h-12'}>
                  <Image alt={'bazar'} className={'object-contain'} sizes={'(max-width: 639px) 20vw, 15vw'} src={'/images/home-screen/logo/bazar-logo.png'}/>
                </Div>
              </Link>
              <Link passHref={true} href={'https://pezeshkbook.com/apps/app'} className={'justify-around flex'} target={'_blank'}>
                <Div className={'relative object-contain w-48 h-12'}>
                  <Image alt={'android'} className={'object-contain'} sizes={'(max-width: 639px) 20vw, 15vw'} src={'/images/home-screen/logo/android-logo.png'}/>
                </Div>
              </Link>
              <Link passHref={true} href={'https://myket.ir/app/com.pezeshkbook'} className={'justify-around flex'} target={'_blank'}>
                <Div className={'relative object-contain w-48 h-12'}>
                  <Image alt={'myket'} className={'object-contain'} sizes={'(max-width: 639px) 20vw, 15vw'} src={'/images/home-screen/logo/myket-logo.png'}/>
                </Div>
              </Link>
            </Div>
          </Div>
        </Div>
      </Div>
    );
  }

  return null;
};

export default DownloadSection;
